import { handleServiceRequest } from './handleServiceRequest';

const baseUrl = `/api/truck-billing`;

export const truckBillingService = {
    searchJobs,
    postWebNotRun,
    postNoPaid,
    postCheckPayment,
};

function searchJobs(date: string, truckNumber: string, statusFilter: string): Promise<any[]> {
    const params = new URLSearchParams({ date, statusFilter });
    if (truckNumber) params.set('truckNumber', truckNumber);
    return handleServiceRequest.get({
        url: `${baseUrl}/jobs?${params.toString()}`,
        customErrorMessage: 'Failed to load truck jobs',
    });
}

function postWebNotRun(jobId: number): Promise<any> {
    return handleServiceRequest.post({
        url: `${baseUrl}/jobs/${jobId}/web-not-run`,
        postBody: {},
        customErrorMessage: 'Failed to update job status',
    });
}

function postNoPaid(jobId: number): Promise<any> {
    return handleServiceRequest.post({
        url: `${baseUrl}/jobs/${jobId}/no-paid`,
        postBody: {},
        customErrorMessage: 'Failed to update job status',
    });
}

function postCheckPayment(jobId: number, data: { checkNumber: string; depositSlipNumber: string; depositSlipDate: string; paymentAmount: number }): Promise<any> {
    return handleServiceRequest.post({
        url: `${baseUrl}/jobs/${jobId}/check-payment`,
        postBody: data,
        customErrorMessage: 'Failed to save check payment',
    });
}
